export default "__VITE_ASSET__DhCmwlGQbWmHGSkti_$C0A__"